import React from "react";
import '../../styles/preloader.css'
const Preloader = ({id}) => {
  return <div id={id} className="preloader"/>;
};

export default Preloader;
